import { render, staticRenderFns } from "./mvMask.vue?vue&type=template&id=382c0f3a"
import script from "./mvMask.vue?vue&type=script&lang=js"
export * from "./mvMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports